module.exports = __webpack_public_path__ + "img/international_thumbnail.dc1f6ca8.png";